import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const apiClient = axios.create({ baseURL: API });

apiClient.interceptors.request.use((cfg) => {
  const tok = localStorage.getItem("ptp_token");
  if (tok) cfg.headers.Authorization = `Bearer ${tok}`;
  return cfg;
});

apiClient.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      // let caller handle
    }
    return Promise.reject(err);
  }
);
